/* collection-hero.js — one-way discrete scroll:
 Scrolling DOWN on the hero locks (smoothly) to the products grid.
 Scrolling UP is fully normal/native — no effect, no barrier (stable, never traps).
 `mode` is kept in sync with the actual scroll position so the down-lock re-arms
 whenever you're back on the hero. Disabled on mobile, coarse pointers, reduced-motion. */
(function () {
  var hero = document.querySelector('[data-collection-hero]');
  if (!hero) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var coarse = window.matchMedia('(pointer: coarse)');
  var small  = window.matchMedia('(max-width: 767px)');
  function enabled() {
    return hero.getAttribute('data-pin') !== 'false'
      && !reduce.matches && !coarse.matches && !small.matches;
  }

  function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }
  function bottomY() { return Math.round(window.scrollY + hero.getBoundingClientRect().bottom); }

  var mode = (window.scrollY >= bottomY() - 2) ? 'products' : 'hero';
  var animating = false;

  function animateTo(targetY) {
    animating = true;
    var startY = window.scrollY, dist = targetY - startY, dur = 1240, t0 = now();
    function ease(p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }
    (function step() {
      var p = Math.min(1, (now() - t0) / dur);
      window.scrollTo(0, Math.round(startY + dist * ease(p)));
      if (p < 1) requestAnimationFrame(step);
      else { animating = false; }
    })();
  }

  /* Down on the hero -> smooth lock to the products. Up + everything else: native. */
  function onWheel(e) {
    if (!enabled() || animating) { if (animating) e.preventDefault(); return; }
    if (e.deltaY > 0 && mode === 'hero' && window.scrollY < bottomY() - 2) {
      e.preventDefault();
      mode = 'products';
      animateTo(bottomY());
    }
  }

  /* Keep mode in sync with where we actually are (every input). No scroll fighting. */
  function onScroll() {
    if (animating) return;
    mode = (window.scrollY < bottomY() - 2) ? 'hero' : 'products';
  }

  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('scroll', onScroll, { passive: true });

  /* The cue glides on EVERY pointer — enabled guards only the wheel scroll-jack.
 on MOBILE the custom RAF loop could finish short of
 the boundary while Safari animates its own chrome — native smooth scroll instead.
 The destination is the masthead, the literal next section; the audit proved
 masthead top == hero bottom (same document coordinate), so nothing moves visually
 except that the browser now owns the animation. Desktop keeps the RAF glide. */
  var cue = hero.querySelector('.ch-cue');
  function mastheadY() {
    var masthead = document.querySelector('.ch-masthead');
    if (!masthead) return bottomY();
/* SEA-LAND16 (2026-09-02): mobile lands 16px into the masthead, so Safari's
 extra top strip (minimized-bars state, ~13pt) only ever shows masthead white.
 Revert = remove "+ (small.matches ? 16 : 0)". */
    return masthead.getBoundingClientRect().top + window.scrollY + (small.matches ? 16 : 0);
  }
  /* v2: native smooth scrolling handed duration/easing to
 Safari and it read as aggressive on-device. Controlled RAF animation instead — same
 deliberate 1240ms cubic as the desktop glide, but: fractional positions on the way
 (no Math.round steps; Safari exposes fractional scroll during its own viewport
 transitions) and a guaranteed exact scrollTo(0, target) as the final statement. */
  function animateMobileTo(targetY) {
    animating = true;
    var startY = window.scrollY, dist = targetY - startY, dur = 1240, t0 = now();
    function ease(p) { return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; }
    (function step() {
      var p = Math.min(1, (now() - t0) / dur);
      if (p < 1) {
        window.scrollTo(0, startY + dist * ease(p));
        requestAnimationFrame(step);
      } else {
        window.scrollTo(0, targetY);
        animating = false;
        lockLanding();
      }
    })();
  }
  /* TEST 1 (duplicate only): THE LANDING LOCK. After the glide lands, Safari
 animates its own toolbar and that transition shifts the page - the measured cause of
 the post-arrow sliver (the 08-20 "bar dance"). React to the browser's own signal:
 on every visualViewport.resize re-read the masthead's REAL position and re-assert it.
 Release on the user's first input, or 1.5s after Safari's last resize event.
 No pixel constants, no device values. */
  function lockLanding() {
    if (!window.visualViewport) return;
    var timer = null, done = false;
    function unlock() {
      if (done) return; done = true;
      clearTimeout(timer);
      visualViewport.removeEventListener('resize', onVV);
      ['touchstart','wheel','keydown'].forEach(function (t) { window.removeEventListener(t, unlock); });
    }
    function onVV() {
      if (done) return;
      window.scrollTo(0, mastheadY());
      clearTimeout(timer); timer = setTimeout(unlock, 1500);
    }
    visualViewport.addEventListener('resize', onVV);
    ['touchstart','wheel','keydown'].forEach(function (t) { window.addEventListener(t, unlock, { passive: true, once: true }); });
    timer = setTimeout(unlock, 1500);
  }
  if (cue) cue.addEventListener('click', function () {
    if (animating) return;
    var target = mastheadY();
    if (reduce.matches) { window.scrollTo(0, target); return; }
    if (small.matches) { animateMobileTo(target); return; }
    mode = 'products';
    animateTo(target);
  });

  /* Below the hero, collapse the header to just the 4 corner icons. Desktop only. */
  function toggleBelow() {
    if (!window.matchMedia('(min-width: 768px)').matches) { document.body.classList.remove('ch-below'); return; }
    if (window.scrollY >= bottomY() - 2) document.body.classList.add('ch-below');
    else document.body.classList.remove('ch-below');
  }
  window.addEventListener('scroll', toggleBelow, { passive: true });
  window.addEventListener('resize', toggleBelow, { passive: true });
  toggleBelow();

})();
